// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__38lOg","range":"MonthRangeSwitch_range__308NZ","disabled":"MonthRangeSwitch_disabled__1Ufuf"};